// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMeta from 'vue-meta'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import App from './App'
import Login from './components/mini-apps/Login.vue'
import router from './router'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import Notifications from 'vue-notification'

import * as VueGoogleMaps from 'vue2-google-maps';

import OCGlobal from './OCGlobal.js'

import moment from 'moment';

const VueUploadComponent = require('vue-upload-component')

Vue.component('file-upload', VueUploadComponent)
Vue.component('v-select', vSelect)
Vue.component('datepicker', Datepicker)
Vue.use(OCGlobal)

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);
Vue.use(Notifications);
Vue.use(Vuex);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

var gmaps_load_params = {
  // key: process.env.NODE_ENV === 'development' ? "AIzaSyCfVbyxCX3EDv7u-mNM_oIrxhxvcOy_fQg" : 'AIzaSyAFGZ0KL3He3dFwYAdTv7nudfyBwCTJKk0',
  // key: '',
  libraries: 'places,visualization', // This is required if you use the Autocomplete plugin
  // OR: libraries: 'places,drawing'
  // OR: libraries: 'places,drawing,visualization'
  // (as you require)

  //// If you want to set the version, you can do so:
  // v: '3.26',
  autobindAllEvents: false,
};

gmaps_load_params.key = 'AIzaSyD8LsAjvR8uka6DQ8yY9YaOIAYyzV3h3tM'; //oc @ gm com

Vue.use(VueGoogleMaps, {
  load: gmaps_load_params,
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

const store = new Vuex.Store({
  state: {
    mapPreference: 'sighting',
    gmapPreference: 'roadmap',
    gmapPreferenceSightingModal: 'roadmap',
  },
  mutations: {
    setgMapPreference (state, mapPref) {
      state.gmapPreference = mapPref;
    },
    setMapPreference (state, mapPref) {
      state.mapPreference = mapPref;
    },
    setgMapPreferenceSightingModal(state, mapPref){
      state.gmapPreferenceSightingModal = mapPref;
    }
  },
  plugins: [createPersistedState()]
});




const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Strip the leading `'./` and extension from the filename
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

router.beforeEach((to, from, next) => {
  $('.bar__module .dropdown--active').removeClass('dropdown--active');
  
  if (typeof to.meta !== 'undefined' && typeof to.meta.title !== 'undefined') {
    document.title = "Odonata Central - " + to.meta.title
  }
  next()
})

Vue.filter('moment', function (date, format) {
  return moment(date).format(format);
})

Vue.filter('formatSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
})

Vue.filter('formatStringDateYYYMMDD', function (dateString) {
  var date_split = dateString.split('-');
  if (date_split.length != 3) {
    return dateString;
  }
  return date_split[1] + "-" + date_split[2] + "-" + date_split[0];
})

Vue.config.productionTip = false;

const global_data = new Vue({
  data: { OCUser: null }
});
export default global_data;

/* eslint-disable no-new */
export const mainApp = new Vue({
  el: '#OCApp',
  store,
  router,
  components: { App },
  template: '<App/>'
})

export const loginApp = new Vue({
  el: '#OCLogin',
  store,
  router,
  components: { Login },
  template: '<Login/>'
})


// WEBPACK FOOTER //
// ./src/main.js